import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';
import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

const ProduccionCalendario = Loadable(lazy(() => import('pages_produccion/calendario')));
const ProduccionOperarioAssignments = Loadable(lazy(() => import('pages_produccion/asignaciones-operarios')));
const ProduccionAssignmentDetail = Loadable(lazy(() => import('pages_produccion/asignaciones-operarios/AssignmentDetail')));
const ProduccionResumenSemanal = Loadable(lazy(() => import('pages_produccion/resumen-semanal')));

const ProductionLayoutGuard = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return <Loader />;
  }
  const normalizedRole = (user?.role || '').toString().trim().toLowerCase();
  const productionRoles = new Set(['admin', 'supervisor', 'produccion']);
  const canAccessProduction = productionRoles.has(normalizedRole);
  if (!canAccessProduction) {
    return <Navigate to="/" replace />;
  }
  return (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  );
};

const ProduccionRoutes = {
  path: '/produccion',
  element: <ProductionLayoutGuard />,
  children: [
    {
      index: true,
      element: <Navigate to="/produccion/asignaciones-operarios" replace />
    },
    {
      path: 'calendario',
      element: <ProduccionCalendario />
    },
    {
      path: 'asignaciones-operarios',
      element: <ProduccionOperarioAssignments />
    },
    {
      path: 'resumen-semanal',
      element: <ProduccionResumenSemanal />
    },
    {
      path: 'asignacion/:assignmentId',
      element: <ProduccionAssignmentDetail />
    },
    {
      path: 'dashboard',
      children: [
        {
          index: true,
          element: <Navigate to="/produccion/calendario" replace />
        },
        {
          path: 'default',
          element: <Navigate to="/produccion/calendario" replace />
        }
      ]
    },
    {
      path: 'media-factura-cobro',
      element: <Navigate to="/produccion/calendario" replace />
    }
  ]
};

export default ProduccionRoutes;
